export default __webpack_public_path__ + "static/Agent List-60d005dbd6ec1981e83533a0a95f063a.pdf";